export const USER_STATUS_TRIAL = 'trial' as const;
export const USER_STATUS_REGISTERED = 'registered' as const;
export const USER_STATUS_ACTIVE = 'active' as const;

export const PRODUCT_G_CONNECTOR = 'g-connector' as const;
export const PRODUCT_XL_CONNECTOR = 'xl-connector' as const;
export const PRODUCT_DATA_CONNECTOR = 'data-connector' as const;

export const PRODUCTS = [
  {
    product_id: PRODUCT_G_CONNECTOR,
    name: 'G-Connector',
  },
  {
    product_id: PRODUCT_XL_CONNECTOR,
    name: 'XL-Connector',
  },
  {
    product_id: PRODUCT_DATA_CONNECTOR,
    name: 'Google Data Connector',
  },
] as const;

export const SUBSCRIPTION_STATUS_ACTIVE = 'active' as const;
export const SUBSCRIPTION_STATUS_IN_TRIAL = 'in_trial' as const;
export const SUBSCRIPTION_STATUS_CANCELLED = 'cancelled' as const;
export const SUBSCRIPTION_STATUS_PAUSED = 'paused' as const;
export const SUBSCRIPTION_STATUS_NON_RENEWING = 'non_renewing' as const;

export const INVOICE_STATUS_PAID = 'paid' as const;
export const INVOICE_STATUS_POSTED = 'posted' as const;
export const INVOICE_STATUS_PAYMENT_DUE = 'payment_due' as const;
export const INVOICE_STATUS_VOIDED = 'voided' as const;
export const INVOICE_STATUS_NOT_PAID = 'not_paid' as const;
export const INVOICE_STATUS_PENDING = 'pending' as const;

export const PLAN_STATUS_ACTIVE = 'active' as const;
export const PLAN_STATUS_ARCHIVED = 'archived' as const;

export const SUBSCRIPTION_OPTION_REACTIVATE = 'reactivate' as const;
export const SUBSCRIPTION_OPTION_PROLONG = 'prolong' as const;
export const SUBSCRIPTION_OPTION_PURCHASE = 'purchase' as const;

export const CARD_STATUS_VALID = 'valid' as const;
export const CARD_STATUS_EXPIRING = 'expiring' as const;
export const CARD_STATUS_EXPIRED = 'expired' as const;
export const CARD_STATUS_PENDING = 'pending_verification' as const;

export const PAYMENT_TYPE_CARD = 'card' as const;
export const PAYMENT_TYPE_CHECKOUT = 'paypal_express_checkout' as const;
export const PAYMENT_TYPE_DIRECTDEBIT = 'direct_debit' as const;

export const PAYMENT_STATUS_REQUIRED = 'required' as const;
export const PAYMENT_STATUS_OPTIONAL = 'optional' as const;
export const PAYMENT_STATUS_VALID = 'valid' as const;